export const PROGRESS_STAGES_DATA = {
  0: {
    stage: 0,
  },
  1: {
    stage: 1,
  },
  2: {
    stage: 2,
  },
  3: {
    stage: 3,
  },
}

export const PROGRESS_STAGES_DATA_ORDERED = [
  PROGRESS_STAGES_DATA[0],
  PROGRESS_STAGES_DATA[1],
  PROGRESS_STAGES_DATA[2],
  PROGRESS_STAGES_DATA[3],
]
